import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import Module from "../pages/Module";
import NavBar from "../components/NavBar";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.Configuration,
    key: "Module",
  };

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={null}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <Module />
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};
